import Dropdown from 'components/dropdown';
import { useState } from 'react';
import { FiAlignJustify } from 'react-icons/fi';
import { MdPerson } from 'react-icons/md';
import { RiMoonFill, RiSunFill } from 'react-icons/ri';
import { Link, useNavigate } from 'react-router-dom';
import { signInService } from 'views/services/auth';

const Navbar = ({
  isSideNavOpen,
  onSideNavOpenChange,
  brandText,
}: {
  isSideNavOpen: boolean;
  onSideNavOpenChange: (isOpen: boolean) => void;
  brandText: string;
  secondary?: boolean | string;
}) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signInService.logout();
    navigate('/auth/sign-in');
  };

  return (
    <nav className="sticky top-0 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <p
            className="inline text-sm font-normal text-navy-700 hover:underline hover:cursor-pointer"
            onClick={() => onSideNavOpenChange(!isSideNavOpen)}
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700">
              {' '}
              /{' '}
            </span>
          </p>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 md:gap-1 xl:gap-2">
        {/* Profile & Dropdown */}
        <button
          className="flex cursor-pointer text-xl text-gray-600 xl:hidden"
          onClick={() => onSideNavOpenChange(!isSideNavOpen)}
        >
          <FiAlignJustify className="h-5 w-5" />
        </button>

        <Dropdown
          button={
            <button className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-600">
              <MdPerson className="h-8 w-8 text-white" />
            </button>
          }
          children={
            <div className="h-25 flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500">
              <div className="ml-4 mt-3">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700">
                    👋 Hey
                  </p>{' '}
                </div>
              </div>
              <div className="mt-3 h-px w-full bg-gray-200" />

              <div className="my-4 ml-4">
                <button
                  className="mt-3 text-sm font-medium text-red-500 hover:text-red-500"
                  onClick={handleLogout}
                >
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames={'py-2 top-8 xs:-left-[180px] '}
        />
      </div>
    </nav>
  );
};

export default Navbar;
